module.exports = __webpack_public_path__ + "static/media/oslogo.098c0f0e.png";